import ImageAtom from "@components/atoms/Image";
import styles from "./GalleryShortsVideoCard.module.scss";
import assetLoader from "@utils/internalImageLoder";

interface VideoType {
  uri: string;
  thumbnail: string;
  title: string;
  locked?: boolean;
}

interface MetadataType {
  title: string;
  thumbnail: string;
  tag: string;
}

interface IProps {
  video: VideoType;
  metadata: MetadataType;
  onClick: (video: any, metadata: any) => void;
  isLoggedIn: boolean;
  brandName?: string;
  modelName?: string;
  pageType?: string;
}

export default function GalleryShortsVideoCard({ video, metadata, onClick, isLoggedIn, brandName, modelName, pageType }: IProps) {
   const handleClick = async () => {
      onClick?.(video, metadata);
    };
  
  return (
    <div className={styles.container} onClick={handleClick}>
      <ImageAtom
        src={video.thumbnail}
        alt={`${video.title} thumbnail`}
        fill
        className={styles.thumbnail}
        onClick={handleClick}
      />

      <div className={styles.overlay}>
        <ImageAtom
          src={`${assetLoader()}/icons/play-icon.svg`}
          alt="play icon"
          width={100}
          height={100}
          className={styles.playIcon}
          onClick={handleClick}

        />
        {video?.locked && (
          <div className={styles.exclusiveBadge}>
            <ImageAtom
              src={`${assetLoader()}/icons/icon-exclusive.svg`}
              alt="Exclusive"
              width={12}
              height={12}
            />
            Exclusive
          </div>
        )}
        <p className={styles.tag}>{metadata.title}</p>
      </div>
    </div>
  );
}
